const STRIP_PREFIXES =
	/^(can you |could you |would you |please |help me |i want to |i need to |i'd like to |i would like to |let's |let me |show me |tell me |give me )/i;
const STRIP_TRAILING = /[.?!]+$/;
const MAX_TITLE_LENGTH = 42;

/**
 * Generates a concise conversation title from the first user message.
 *
 * Uses heuristics to strip filler words and extract the core topic.
 * This runs client-side for immediate feedback. A backend AI-generated
 * title endpoint can replace this in the future for higher quality.
 */
export function generateConversationTitle(firstMessage: string): string {
	let title = firstMessage.trim();

	title = title.replace(STRIP_PREFIXES, '');
	title = title.replace(STRIP_PREFIXES, '');
	title = title.replace(STRIP_TRAILING, '');
	title = title.charAt(0).toUpperCase() + title.slice(1);

	if (title.length > MAX_TITLE_LENGTH) {
		const cutoff = title.lastIndexOf(' ', MAX_TITLE_LENGTH);
		title = title.slice(0, cutoff > 20 ? cutoff : MAX_TITLE_LENGTH) + '...';
	}

	return title;
}

function getTimeOfDayLabel(): string {
	const now = new Date();
	const day = now.toLocaleDateString('en-US', { weekday: 'long' });
	const hour = now.getHours();
	const period = hour < 12 ? 'morning' : hour < 17 ? 'afternoon' : 'evening';
	return `${day} ${period}`;
}

/**
 * Returns the title for the current active conversation.
 * Before any messages: time-of-day label (e.g. "Wednesday afternoon").
 * After the first user message: smart title from the message content.
 */
export function getActiveConversationTitle(firstUserMessage: string | undefined): string {
	if (!firstUserMessage) return getTimeOfDayLabel();
	return generateConversationTitle(firstUserMessage);
}
